// Меню в шапке одно на все разрешения: на ширине <= 1160px оно раскрывается по бургеру,
// а пункты с подменю работают как аккордеон.
const MOBILE_MENU_QUERY = window.matchMedia('(max-width: 1160px)');

const header = document.querySelector('header');
const menuItems = header.querySelectorAll('.topbar-links > .topbar-item');
const mobileIcon = header.querySelector('.header__mobile_btn');

function toggleMenu() {
  header.classList.toggle('open');
  if (document.body.style.overflow === 'auto') document.body.style.overflow = '';
  document.body.classList.toggle('disable');
}

function closeMenu() {
  header.classList.remove('open');
  document.body.classList.remove('disable');
}

function getSubmenu(item) {
  return item.querySelector('.submenu_block');
}

// в раскрытом меню у пунктов с подменю своя стрелка — та же, что была в мобильном меню
function addMenuArrow(item) {
  const icon = document.createElement('div');

  icon.classList.add('topbar-item__icon');
  icon.innerHTML =
    '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M6.35355 8.35355C6.15829 8.54882 5.84171 8.54882 5.64645 8.35355L2.64645 5.35355C2.45118 5.15829 2.45118 4.84171 2.64645 4.64645C2.84171 4.45118 3.15829 4.45118 3.35355 4.64645L6 7.29289L8.64645 4.64645C8.84171 4.45118 9.15829 4.45118 9.35355 4.64645C9.54882 4.84171 9.54882 5.15829 9.35355 5.35355L6.35355 8.35355Z" fill="currentColor"/>\n' +
    '</svg>\n';

  item.children[0].appendChild(icon);
}

function toggleSubmenu(item) {
  item.classList.toggle('topbar-item_nest');
  item.children[0].classList.toggle('active');
  getSubmenu(item).classList.toggle('submenu_block_active');
}

function closeSubmenus() {
  menuItems.forEach((item) => {
    if (!getSubmenu(item)) return;

    item.classList.remove('topbar-item_nest');
    item.children[0].classList.remove('active');
    getSubmenu(item).classList.remove('submenu_block_active');
  });
}

menuItems.forEach((item) => {
  if (getSubmenu(item)) addMenuArrow(item);

  item.addEventListener('click', (event) => {
    // на десктопе выпадающими списками управляет submenu.js
    if (!MOBILE_MENU_QUERY.matches) return;

    const submenu = getSubmenu(item);

    // клик по самому пункту раскрывает подменю, клик по ссылке — закрывает меню
    if (submenu && !submenu.contains(event.target)) {
      toggleSubmenu(item);
      return;
    }

    closeMenu();
  });
});

mobileIcon.addEventListener('click', toggleMenu);

MOBILE_MENU_QUERY.addEventListener('change', (event) => {
  if (event.matches) return;

  closeMenu();
  closeSubmenus();
});
